import { useRef, useState } from "react";
import { format, isValid, parseISO } from "date-fns";
import { useDashLead } from "./hooks/useDashLead";
import {
  FilterModal,
  DashboardHeader,
  KPISection,
  ConversionFunnel,
  PlansGrid,
} from "./components";
import { handleEnterFullscreen } from "../fullScreen";
import { LeadsByConsultant } from "./components/LeadsByConsultant";
import { LeadsByMetrics } from "./components/LeadsByMetrics";
import { useLeadFilters } from "@/modules/leads/hooks/useLeadFilters";
import Loading from "@/common/components/ui/loading/Loading";

export default function LeadsDashboard() {
  const {
    displayCompanyName,
    plansTotals,
    plansTooltips,
    isFiltering,
    kpisFilter,
    kpisToday,
    //activationsToday,
    //reactivationsToday,
    activationsFilter,
    reactivationsFilter,
    tma,
    leadsByTime,
    projectionUntilToday,
    refetch,
    //dailyGoal,
    monthGoal,
    leadsByOrigin,
    leadsByConsultant,
    loading,
    leadsByCompany,
    leadsByCompanyFilter,
    activationsByConsultant
  } = useDashLead();

  const { applyFilters, filters } = useLeadFilters();
  const [modal, setModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState({ screen: 'today' , value: false });

  const OpenrModal = () => setModal(true);
  const CloseModal = () => setModal(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const handleFullscreen = () => {
    handleEnterFullscreen(containerRef.current);
  };

  const { dateRange } = filters;
  const { start: startDate, end: endDate } = dateRange;

  const formattedPeriod = startDate && endDate && isValid(parseISO(startDate)) && isValid(parseISO(endDate))
    ? `${format(parseISO(startDate), "dd/MM/yyyy")} até ${format(parseISO(endDate), "dd/MM/yyyy")}`
    : "Data inválida";

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loading />
      </div>
    );
  }

  return (
    <>
      <DashboardHeader
        companyName={displayCompanyName}
        onOpenFilter={OpenrModal}
        isRefreshing={isFiltering}
        onFullscreen={handleFullscreen}
        refetch={refetch}
      />
      <div ref={containerRef} className="p-4 sm:p-6 bg-white">
        <FilterModal
          isOpen={modal}
          onClose={CloseModal}
          onApply={() => applyFilters(refetch)}
        />

        <LeadsByMetrics
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          leadsByTime={leadsByTime as unknown as Record<string, Record<string, number>>}
          leadsByCompany={leadsByCompany}
          leadsByOrigin={leadsByOrigin}
          leadsByCompanyFilter={leadsByCompanyFilter}
        />

        <div className="flex">
          <div className="flex gap-8">
            <KPISection
              className="w-[65%]"
              type="today"
              title="Hoje"
              kpis={kpisToday}
              loading={isFiltering}
              onTotalLeadsClick={(city?: string) => setIsModalOpen({ screen: city ?? "today", value: true })}
              leadsByTime={leadsByTime}
              leadsByCompany={leadsByCompany}
            />

            <div className="bg-slate-100 w-1" />

            <KPISection
              type="period"
              title="Período Selecionado"
              subtitle={formattedPeriod}
              kpis={kpisFilter}
              activations={activationsFilter}
              reactivations={reactivationsFilter}
              tma={tma}
              projectionUntilToday={projectionUntilToday}
              loading={isFiltering}
              monthGoal={monthGoal ?? 0}
              onTotalLeadsClick={() => setIsModalOpen(() => ({ screen: "period", value: true }))}
            />
          </div>
        </div>
      </div>
      <div className="p-4 sm:p-6 bg-white">
        <div className="flex gap-4">
          <LeadsByConsultant 
            leadsByConsultant={leadsByConsultant} 
            activationsByConsultant={activationsByConsultant}
          />
        </div>
          
        <div className="flex justify-center mt-6">
          <PlansGrid
            plansTotals={plansTotals}
            plansTooltips={plansTooltips}
          />
          <ConversionFunnel
            kpis={kpisFilter}
            loading={isFiltering}
          />
        </div>
      </div>
    </>
  );
}
